import { createContext } from 'react';

import { type PushNotif } from '../notification';

export const notificationsContext = createContext<PushNotif | undefined>(
  undefined,
);

export const NotificationsContextProvider = notificationsContext.Provider;
